var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1755",
    "data-name": "Group 1755",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 118.678,
    height: 181,
    viewBox: "0 0 118.678 181",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2713",
    "data-name": "Rectangle 2713",
    width: 118.678,
    height: 181,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2712",
    "data-name": "Rectangle 2712",
    width: 118.678,
    height: 181,
    rx: 10,
    transform: "translate(0)",
    fill: "#cad9f9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1576",
    "data-name": "Group 1576",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1575",
    "data-name": "Group 1575",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2942",
    "data-name": "Path 2942",
    d: "M278.624,73.519l6.158-38.9a37.788,37.788,0,0,1,21.689,11.056Z",
    transform: "translate(-175.874 -20.369)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2943",
    "data-name": "Path 2943",
    d: "M222.313,72.759,250.16,44.913a39.385,39.385,0,1,1-55.7,0,38.2,38.2,0,0,1,34.009-11.052Z",
    transform: "translate(-119.563 -19.609)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2944",
    "data-name": "Path 2944",
    d: "M278.615,89.317l17.877,35.092a39.389,39.389,0,0,0,17.216-52.971,37.441,37.441,0,0,0-7.245-9.968Z",
    transform: "translate(-175.869 -36.17)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2945",
    "data-name": "Path 2945",
    d: "M69.773,310.172,61.2,301.6l16.836-16.818,8.562,8.58Z",
    transform: "translate(-47.939 -167.57)",
    fill: "#0253a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2946",
    "data-name": "Path 2946",
    d: "M155.88,177.729a39.9,39.9,0,1,0-11.691,28.189,39.551,39.551,0,0,0,11.691-28.189m-39.8,31.562a31.512,31.512,0,1,1,22.262-9.22,31.371,31.371,0,0,1-22.262,9.22",
    transform: "translate(-56.727 -81.109)",
    fill: "#0063cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2947",
    "data-name": "Path 2947",
    d: "M17.5,345.724,2.582,330.8l26.6-26.571,14.91,14.929Z",
    transform: "translate(-13.446 -179.013)",
    fill: "#0063cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2948",
    "data-name": "Path 2948",
    d: "M17.5,353.717,2.583,338.788l21-20.982L38.5,332.738Z",
    transform: "translate(-13.446 -187.004)",
    fill: "#387bff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_92",
    "data-name": "Line 92",
    y1: 11.18,
    x2: 11.193,
    transform: "translate(8.338 141.634)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2949",
    "data-name": "Path 2949",
    d: "M11.51,387.208A11.516,11.516,0,0,1,0,375.687q1.38-1.382,2.764-2.762,5.758,5.763,11.512,11.518-1.381,1.383-2.766,2.765",
    transform: "translate(-11.926 -219.436)",
    fill: "#0063cb"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep5);
export default __webpack_public_path__ + "static/media/step5.4cb7dd4b6ee3a2da56264e58c720af64.svg";
export { ForwardRef as ReactComponent };